

export class ExecutivePlan {
    clause?: string;
    endDate?: Date;
    id?: number;
    responsibleName?: string;
    responsiblePosition?: string;
    startDate?: Date;
    visitId?: number;
    visitKey?: string;
    requiredResources?: string;
    expectedOutputs?: string;
    evidences?: any[];

    deleted: boolean;
}